
define('unknown/views/recoverView',[
	'jquery',
	'underscore',
	'backbone',
	'unknown/models/recoverModel',
], function($, _, Backbone, RecoverModel){
	var RecoverFooterView = Backbone.View.extend({
		events: {
			'click #recoverFormSubmit': 'submitRecoverForm'
		},
		
		initialize: function(options) {
			this.event = options.event;
			
			this.showForm();
			
			this.listenTo(this.event, 'default', this.showForm);
			this.listenTo(this.event, 'saving', this.showNonForm);
			this.listenTo(this.event, 'error', this.showForm);
			this.listenTo(this.event, 'success', this.showNonForm);
		},
		
		submitRecoverForm: function () {
			this.event.trigger("save");
		},
		
		showForm: function () {
			this.$("#recoverFormSubmit").show();
		},
		
		showNonForm: function () {
			this.$("#recoverFormSubmit").hide();
		},
	});

	var RecoverContentView = Backbone.View.extend({	
		initialize: function(options) {
			this.hideAll();
			
			this.recoverModel = options.recoverModel;
			this.event = options.event;
			this.submittedData = options.submittedData;
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			_.bindAll(this, 'formEnter');
			
			$('#recoverBodyContentForm').on("keyup", this.formEnter);
			
			this.listenTo(this.event, 'save', this.submitRecover);
			this.listenTo(this.event, 'default', this.form);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.form);
			this.listenTo(this.event, 'success', this.success);
			
			//Error handling
			this.listenTo(this.event, 'error:email', this.errorEmail);
		},
		
		submitRecover: function () {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				
				this.submittedData.isSubmitted = true;
				
				this.recoverModel.save({
					email: this.$("#recoverEmailInput").val()
				},{wait: true,
					success : this.successCallback, 
					error : this.errorCallback
				});
			}			
		},
		
		successCallback: function(model, response) {
			this.event.trigger("savingSuccess", model, response);
		},
		
		errorCallback: function(model, error) {
			this.event.trigger("savingError", model, error);
		},
		
		formEnter: function(e) {
			var code = e.keyCode || e.which; 
			if (code  == 13) {               
				e.preventDefault();
				this.event.trigger("save");
				return false;
			}
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			this.$("#recoverBodyContentForm").hide();
			this.$("#recoverBodyContentProcessing").hide();
			this.$("#recoverBodyContentSuccess").hide();
			
			//Hide error messages
			this.$("#recoverEmailGrp").removeClass("error");
			this.$("#recoverEmailInput").removeClass("error");
			this.$("#recoverEmailErrMsg").hide();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#recoverBodyContentSuccess").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#recoverBodyContentProcessing").show();
		},
		
		form: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#recoverBodyContentForm").show();
		},
		
		errorEmail : function (errorCode) {
			this.$("#recoverEmailGrp").addClass("error");
			this.$("#recoverEmailInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#recoverEmailErrMsg").html("Email is empty");
					this.$("#recoverEmailErrMsg").show();
					break;
				case "EMAIL": 
					this.$("#recoverEmailErrMsg").html("Invalid email address");
					this.$("#recoverEmailErrMsg").show();
					break;
				case "USERNOTEXIST": 
					this.$("#recoverEmailErrMsg").html("Email address does not belong to anyone");
					this.$("#recoverEmailErrMsg").show();
					break;
				default : 
					this.$("#recoverEmailErrMsg").html("Invalid email address");
			}
		},
	});

	var RecoverMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.success);
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			this.$("#recoverBodyMessageError").hide();
			this.$("#recoverBodyMessageProcessing").hide();
			this.$("#recoverBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#recoverBodyMessageError").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#recoverBodyMessageSuccess").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#recoverBodyMessageProcessing").show();
		},
	});
	
	var RecoverView = Backbone.View.extend({
		el: $("#recoverContent"),
		
		initialize: function(options) {
			this.recoverModel = options.recoverModel;
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};			
			
			this.message = new RecoverMessageView({el: this.$("#recoverBodyMessage"), event: this.event});
			this.content = new RecoverContentView({
				el: this.$("#recoverBodyContent"), 
				event: this.event, 
				recoverModel: this.recoverModel,
				submittedData: this.submittedData});
			this.footer = new RecoverFooterView({el: this.$("#recoverFooter"), event: this.event});
			
			this.listenTo(this.event, 'savingSuccess', this.recoverSuccess);
			this.listenTo(this.event, 'savingError', this.recoverError);
		},
		
		render: function () {
			this.event.trigger("default");
			return this;
		},
		
		recoverError: function(model, error) {		
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else if (error.status == 404) {
					this.event.trigger("error");
					this.event.trigger("error:email", "USERNOTEXIST");
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		recoverSuccess: function () {
			this.submittedData.isSubmitted = false;
			this.event.trigger("success");
		},
	});
	
	return RecoverView;  
});